import * as style from './style.module.css';

const Grid = ({ children }) => {
    return <div className={style.grid}>{children}</div>;
};

export default Grid;
